module.exports = "https://and-static.ghzs.com/web/bbs-desktop/static/img/icon_ranking1.eeb92.png";